let _ = require('lodash');

module.exports = {
    addVideo (args, state, output, { context }) {
        var scheme = _.get(context, 'location.scheme');
        let ytplayer = document.getElementById('ytplayer');
        let iframe = document.createElement('iframe');
        iframe.setAttribute('type', 'text/html');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('src', `${scheme}://www.youtube.com/embed/XzXUsfC_Jt8?origin=${scheme}://data.2gis.com`);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        ytplayer.parentNode.replaceChild(iframe, ytplayer);
    }
};



// WEBPACK FOOTER //
// ./actions/video.js